import * as yup from "yup";
import { FormInputMeta } from "@Modules/core/types/FormMetaType";
import { getValidationSchema } from "@Shared/utils/validationSchema";

export interface IAuthorizationsConsultationDataTableRowFormMeta {
  oneDate: FormInputMeta,
  authorizationNumber: FormInputMeta,
  PAN: FormInputMeta,
  dateExp: FormInputMeta,
  amount: FormInputMeta,
  mon: FormInputMeta,
  repo: FormInputMeta,
  status: FormInputMeta,
  statA: FormInputMeta,
  
  schema: any,
}

const AuthorizationsConsultationDataTableRowFormMeta = {} as IAuthorizationsConsultationDataTableRowFormMeta;

AuthorizationsConsultationDataTableRowFormMeta.oneDate = {
  name: "oneDate",
  type: "date",
  label: "Date",
  placeholder: "",
  validation: yup.date().required("Champ obligatoire !")
};

AuthorizationsConsultationDataTableRowFormMeta.authorizationNumber = {
  name: "authorizationNumber",
  type: "text",
  label: "Numero autorisation",
  placeholder: "",
  validation: yup.date().required("Champ obligatoire !")
};

AuthorizationsConsultationDataTableRowFormMeta.PAN = {
  name: "PAN",
  type: "text",
  label: "PAN",
  placeholder: "",
  validation: yup.date().required("Champ obligatoire !")
};

AuthorizationsConsultationDataTableRowFormMeta.dateExp = {
  name: "dateExp",
  type: "date",
  label: "Date Exp.",
  placeholder: "",
  validation: yup.date().required("Champ obligatoire !")
};

AuthorizationsConsultationDataTableRowFormMeta.amount = {
  name: "amount",
  type: "text",
  label: "Montant",
  placeholder: "",
  validation: yup.date().required("Champ obligatoire !")
};

AuthorizationsConsultationDataTableRowFormMeta.mon = {
  name: "mon",
  type: "text",
  label: "Mon.",
  placeholder: "",
  validation: yup.date().required("Champ obligatoire !")
};

AuthorizationsConsultationDataTableRowFormMeta.repo = {
  name: "repo",
  type: "text",
  label: "Répo.",
  placeholder: "",
  validation: yup.date().required("Champ obligatoire !")
};

AuthorizationsConsultationDataTableRowFormMeta.status = {
  name: "status",
  type: "text",
  label: "Statut",
  placeholder: "",
  validation: yup.date().required("Champ obligatoire !")
};

AuthorizationsConsultationDataTableRowFormMeta.statA = {
  name: "statA",
  type: "text",
  label: "Stat. A.",
  placeholder: "",
  validation: yup.date().required("Champ obligatoire !")
};


AuthorizationsConsultationDataTableRowFormMeta.schema = yup.object().shape(getValidationSchema(AuthorizationsConsultationDataTableRowFormMeta));

export default AuthorizationsConsultationDataTableRowFormMeta;
